import { API_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';
import { getAuthHeader } from '~/modules/common/utils/cookieUtils';

const base = API_URL + '/v3.5';

/**
 * Notification Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */
export const notificationService = (http, cookies) => ({
  /**
   * Get Notification List
   *
   * @param {object} params object
   * @param {number} [params.page]
   * @param {number} [params.limit]
   */
  async getNotificationList({ page, limit } = {}) {
    const queryParams = encodeQuery({ limit, page });
    const { data, pagination } = await http.$get(`${base}/notifications${queryParams}`, {
      headers: getAuthHeader(cookies),
    });
    return { data, pagination };
  },

  /**
   * Get Notification count
   *
   */
  async getNotificationCount() {
    const { data } = await http.$get(`${base}/notifications/count`, {
      headers: getAuthHeader(cookies),
    });
    return { data };
  },

  /**
   * Update Notification status
   *
   */
  async updateNotificationStatus(params) {
    const { data } = await http.post(`${base}/notifications/update`, params, {
      headers: getAuthHeader(cookies),
    });
    return { data };
  },
});
